/*
*  Dialog View for user to confirm that they want to remove their
*  credit card information from the server.  
*/
let template = `<div class="modal-dialog modal-md">
    <div class="modal-content">
        <div class="modal-header">
            Remove Payment Method
            <button class="btn-close" data-dismiss="modal"><span class="fa fa-times"></span></button>
            <div class="modal-alert-container">
                <div class="alert"></div>
            </div>
        </div>
        <div class="modal-body">
            <p>Removing your linked payment method will limit cellular device functionality.</p>
        </div>
        <div class="modal-footer">
            <button class="btn btn-link" data-dismiss="modal">Cancel</button>
            <button type="submit" class="btn btn-danger">Delete</button>
        </div>
    </div>
</div>`;

import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import DialogInterface from '@/interfaces/dialog';

const RemovePaymentDialogView = Marionette.View.extend(DialogInterface).extend({
    template: Handlebars.compile(template),
    ui: {
        'delete_card': 'button[type="submit"]'
    },
    events: {
        'click @ui.delete_card': 'delete_card',
    },
    initialize: function (options) {
        this.destroyOnClose();
    },
    templateContext: function(){
        return this.getOption('payment_data');
    },
    delete_card: function(e) {
        e.preventDefault();
        const globalCh = Radio.channel('global');
        const primary = globalCh.request('primary_account');
        primary.delete_stripe_payment_method()
        .then( (resp)=>{
            delete this.getOption('payment_info');
            this.closeDialog();
            globalCh.request('show_billing', primary);
            Radio.request('alerts', 'showAlert', {
                message: `Successfully removed card information from account`,
                messageType: 'success'
            }); 
        })
        .catch((response) => {
            const errorText = response && response.responseJSON && response.responseJSON.errors.length && response.responseJSON.errors[0].detail;
            this.showAlert('alert-danger', errorText || 'Error submitting payment, please try again');
        });
    }
});
export default RemovePaymentDialogView;

